// extracted by mini-css-extract-plugin
export default {"main":"DeleteManStyle_main__uVGE+","btns":"DeleteManStyle_btns__7QitX","cancel":"DeleteManStyle_cancel__obAo9","delete":"DeleteManStyle_delete__4nPOK"};